"use strict";
// Zod-free types for the mapping engine. The package root re-exports only from here (and the
// runtime modules), so browser consumers like jitsu-js don't bundle zod. The zod schemas live
// in ./schemas and are exposed as "@jitsu/mapping-engine/schemas"; a compile-time check there
// keeps them in sync with these types.
//
// The types describe mappings as they are stored and passed around (the schema's input), not as the
// schema outputs them: consumers receive connection options without schema defaults applied, so
// `enabled` and `eventType` may be missing. A missing `eventType` is treated as "*" and a missing
// `enabled` as disabled.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MAPPINGS_PER_CONNECTION = void 0;
exports.MAX_MAPPINGS_PER_CONNECTION = 50;
